module.exports = __webpack_public_path__ + "img/meter-on-red.e582f487.svg";